import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AgendaFilterService {
  private _filteredIds = signal<string[]>([]);
  filteredIds = computed(() => this._filteredIds());

  filterAgendas(ids: string[]) {
    this._filteredIds.set(ids);
  }
}
